import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { MyThunkDispatch, RootState } from 'store';

import { fetchCountryList, fetchRestCountryList } from 'actions/i18n';
import RegistrationOnboarding from 'screens/components/RegistrationOnboarding';
import { resendTwoFactor } from 'services/otpService';
import {
  createEmail,
  CreateCorporateEmailRequest,
  verifyLinkedRappiUser,
  VerifyLinkedRappiUserParameters,
  setCountry,
  SetCountryRequest,
  setCompany,
  SetCompanyRequest,
  createCompany,
  CreateCompanyRequest,
  linkRappiUser,
  LinkRappiUserRequest,
} from 'services/registrationService';

const RegistrationOnboardingContainer = () => {
  const dispatch: MyThunkDispatch = useDispatch();

  const { loadingCountries, countryList, restCountries } = useSelector((state: RootState) => state.i18n);

  const fetchCountryCodes = () => dispatch(fetchRestCountryList());
  const fetchAvailableCountries = () => dispatch(fetchCountryList());

  const sendEmail = (data: CreateCorporateEmailRequest) => createEmail(data);
  const verifyLinkedUser = (data: VerifyLinkedRappiUserParameters) => verifyLinkedRappiUser(data);
  const sendCountry = (data: SetCountryRequest, id: string) => setCountry(data, id);
  const sendCompany = (data: SetCompanyRequest, id: string) => setCompany(data, id);
  const create = (data: CreateCompanyRequest) => createCompany(data);
  const linkUser = (data: LinkRappiUserRequest) => linkRappiUser(data);
  const resendTwoFactorAuth = (key: string) => resendTwoFactor(key);

  return (
    <RegistrationOnboarding
      fetchAvailableCountries={fetchAvailableCountries}
      fetchCountryCodes={fetchCountryCodes}
      sendEmail={sendEmail}
      verifyLinkedUser={verifyLinkedUser}
      sendCountry={sendCountry}
      sendCompany={sendCompany}
      createCompany={create}
      linkRappiUser={linkUser}
      loadingCountries={loadingCountries}
      countryList={countryList}
      restCountries={restCountries}
      resendTwoFactor={resendTwoFactorAuth}
    />
  );
};

export default RegistrationOnboardingContainer;
